document.addEventListener("DOMContentLoaded", () => {

    const carrusel = document.querySelector(".contenedor-tarjetas-carrusel-productos");

    if (!carrusel) return;

    // Convertimos a array las tarjetas originales
    let tarjetas = Array.from(carrusel.children);

    // 🔀 MEZCLAR (Fisher-Yates)
    for (let i = tarjetas.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [tarjetas[i], tarjetas[j]] = [tarjetas[j], tarjetas[i]];
    }

    // Limpiamos el contenedor (por seguridad)
    carrusel.innerHTML = "";

    // 🔁 Reinsertamos en orden aleatorio
    tarjetas.forEach(tarjeta => carrusel.appendChild(tarjeta));

    // ♾️ Duplicamos dinámicamente para loop infinito
    const tarjetasOriginales = [...carrusel.children];

    tarjetasOriginales.forEach(tarjeta => {
        const clon = tarjeta.cloneNode(true);
        carrusel.appendChild(clon);
    });

});